module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-angry.4553dcd6.png";